import React from 'react'

const SigninPage = () => {
  return (
    <div>Sign in Page</div>
  )
}

export default SigninPage